import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon,  MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Card  } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined } from '@ant-design/icons';

export default class Getprograme extends Component {
    constructor(props) {
        super(props);
        this.state = {
         teacher:[],
         term:'',
         idemp:'',
         teacher_id2:'',
         name:'',
         prenm:'',
         t_mjname:'',
         id_major:'',
         id_major2:'66666',
          

        };
       // this.handleChange = this.handleChange.bind(this);
      }

      componentWillReceiveProps() {
        this.setState({ id_major :this.props.id_major})
        this.setState({ id_major2 :this.props.id_major.substring(3, 2)})
       // console.log(this.props.id_major.substring(2, 2))
        setTimeout(() => {
           //ภายใน
           Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/showprograme/'+this.props.id_major.substring(3, 2)+'/'+this.props.id_major)
           .then(res => {
            // console.log('sdsd');
            // console.log(res.data[0].t_mjname);
            //  this.setState({ bankname: res.data, loading: false })
             this.setState({ teacher: res.data})

          //  const teachersearcha = res.data.filter( ({ user_teacher }) => user_teacher === this.props.teacher_id2 );
          //  console.log(teachersearcha[0].poname);
            this.setState({ t_mjname: res.data[0].t_mjname});
           // this.setState({ prenm: teachersearcha[0].prenm});
           }) 
         }, 0);
       

      }
      componentDidMount() {
      
        this.setState({ id_major :this.props.id_major})
        this.setState({ id_major2 :this.props.id_major.substring(3, 2)})
       // console.log(this.props.id_major.substring(2, 2))
        setTimeout(() => {
           //ภายใน
           Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/showprograme/'+this.props.id_major.substring(3, 2)+'/'+this.props.id_major)
           .then(res => {
           // console.log('sdsd');
            // console.log(res.data[0].t_mjname);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ teacher: res.data})
             this.setState({ t_mjname: res.data[0].t_mjname});
          //  const teachersearcha = res.data.filter( ({ user_teacher }) => user_teacher === this.props.teacher_id2 );
          //  console.log(teachersearcha[0].poname);
           
           // this.setState({ prenm: teachersearcha[0].prenm});
           }) 
         }, 0);
        // this.getthcouncil();


      }

    

    render() {
        console.log(this.state.id_major2)
        return (
            <>
                 {this.state.t_mjname}
            </>
        )
    }
}
